import { createReduxEssentials } from '@helpers/createReduxEssentials'

import { GLOBAL_STATE, actionNames } from '../constants/actionTypes'

const { actions, actionTypes, selectors, reducer } = createReduxEssentials(actionNames, GLOBAL_STATE)

export const CATEGORY = GLOBAL_STATE

export { reducer, actionTypes, actions, selectors }
